// prettier-ignore
const template = (i,data, selectedCategory) => {
    return `<div class="radio">
    <input type="radio" class="radio__input" id="search-category-${i}" name="category" value="${data.category}"
        data-element="input" ${data.category === selectedCategory ? 'checked' : ''}>
    <label for="search-category-${i}" class="radio__label">${data.category} <small>(${data.results})</small></label>
</div>`
}
export default template
